import { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { debounce } from "lodash";
import ClipLoader from "react-spinners/ClipLoader";
import AsyncSelect from "react-select/async";
import { UserContext } from "../../../../Context/UserContext";
import { BaseURL } from "../../../../Reusable/BaseURL";

export const DirectGPUpdUnitSelect = ({
  selectedOption,
  setSelectedOption,
  unitByItem,
  changingSelect,
  setChangingSelect,
}) => {
  const { darkTheme, loginData } = useContext(UserContext);

  const [options, setOptions] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // async function initialFetchUnit() {
  //   setIsLoading(true);
  //   const response = await fetch(`${BaseURL}/units?q=${selectedOption}`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   });
  //   const data = await response.json();
  //   const transformedOptions = data.data.data.map((item) => ({
  //     value: item.id,
  //     label: item.name,
  //   }));
  //   setOptions(transformedOptions);
  //   if (data.status === true || data.status === false) {
  //     setIsLoading(false);
  //   }
  // }

  // Fetch initial data on component mount
  const fetchInitialData = async () => {
    try {
      // if (selectedOption === "") {
      //   const response = await fetch(`${BaseURL}/units`, {
      //     method: "GET",
      //     headers: {
      //       Accept: "application/json",
      //       Authorization: `Bearer ${loginData.token}`,
      //     },
      //   });
      //   const data = await response.json();
      //   const transformedOptions = data.data.data.map((item) => ({
      //     value: item.id,
      //     label: item.name,
      //   }));
      //   setOptions(transformedOptions);

      // }
      // else{
      setIsLoading(true);
      const response = await fetch(`${BaseURL}/units?q=${unitByItem.unit}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      });
      const data = await response.json();
      const myFilter = data.data.data.filter(
        (item) => item.name === unitByItem.unit
      );
      const transformedOptions = myFilter.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      const myFind = transformedOptions.find(
        (item) => item.label === unitByItem.unit
      );
      if(myFind){
        setSelectedOption(myFind);
      }
      if (data.status === false || data.status === true) {
        setIsLoading(false);
      }
      // console.log("myFilterDivi::", myFilter)
      // console.log("myMapDivi::", transformedOptions)
      // console.log("myFindDivi::", myFind)
      // }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };
  useEffect(() => {
    fetchInitialData(selectedOption ? selectedOption : unitByItem.unit);
    setChangingSelect(false)
  }, [unitByItem, changingSelect]);

  // useEffect(() => {
  //   fetchInitialData(unitByItem.unit);
  // }, [unitByItem]);
  // useEffect(() => {
  //   fetchInitialData(selectedOption);
  // }, [changingSelect]);

  // useEffect(()=>{
  //   if(selectedOption === ""){
  //     initialFetchUnit()
  //   }else{
  //     initialFetchUnit()
  //   }
  // }, [])

  // Function to fetch data based on input
  // const fetchData = useCallback(
  //   debounce(async (input) => {
  //     setIsLoading(true);
  //     const API_URL = `${BaseURL}/units?q=${input}`;
  //     const response = await fetch(API_URL, {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${loginData.token}`,
  //       },
  //     });
  //     const data = await response.json();
  //     const transformedOptions = data.data.data.map((item) => ({
  //       value: item.id,
  //       label: item.name,
  //     }));
  //     setOptions(transformedOptions);
  //     if (data.status === false || data.status === true) {
  //       setIsLoading(false);
  //     }
  //   }, 300),
  //   []
  // );
  
  // useEffect(()=>{
  //   fetchData(inputValue)
  // },[])

  // Function to load options based on user input
  const loadOptions = (inputValue, callback) => {
    fetch(`${BaseURL}/units?q=${inputValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const options = data.data.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        callback([]);
      });
  };
  const debouncedLoadOptions = debounce(loadOptions, 400);

  // const handleFocus = (event) => {
  //   fetchData(inputValue);
  // };

  // // Handle input change
  // const handleInputChange = (newValue) => {
  //   setInputValue(newValue);
  //   fetchData(newValue);
  // };

  // Handle option select
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  // Custom styling
  const customStyles = {
    // loading style
    // menuList: (provided) => ({
    //   ...provided,
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   minHeight: "50px",
    //   flexDirection: "column",
    //   textTransform: "uppercase",
    // }),

    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "#fffa" : "#111a"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const MenuList = (props) => {
    const { isLoading, children } = props;
    return (
      <components.MenuList {...props}>
        {isLoading ? (
          <div
            style={
              {
                // display: "flex",
                // flexDirection: "row",
                // justifyContent: "center",
                // alignItems: "center",
                // height: "100%",
              }
            }
          >
            <ClipLoader color="#000" loading={isLoading} size={30} />
          </div>
        ) : (
          children
        )}
      </components.MenuList>
    );
  };

  return (
    <AsyncSelect
      // onFocus={handleFocus}
      styles={customStyles}
      
      cacheOptions
      loadOptions={debouncedLoadOptions}
      defaultOptions
      
      onChange={handleChange}
      value={selectedOption}
      placeholder="Select"
      isLoading={isLoading}
      // components={{
      //   MenuList: (props) => <MenuList {...props} isLoading={isLoading} />,
      // }}
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
      isDisabled={!unitByItem}
    />
  );
};
